import angular from 'angular';
import IComplianceAppDataService from './IComplianceApp.data.service';
import * as R from 'ramda';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

let _upload;

export class ecatDataService extends IComplianceAppDataService {
  constructor(
    $http,
    Upload,
    utilityService // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'ecat');
    _upload = Upload;

    console.log('app.services.ecatDataService created');
  }

  getAssessments() {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment`,
      method: 'GET',
    });
  }

  getAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}`,
      method: 'GET',
    });
  }

  checkAllowNewAssessment() {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/allowNew`,
      method: 'GET',
    });
  }

  checkCanCompleteAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/canComplete`,
      method: 'GET',
      data: {},
    });
  }

  checkAssessmentExists(name, assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/checkExists/`,
      method: 'GET',
      params: {
        id: assessmentId,
        name
      }
    });
  }

  saveAssessment(assessmentId, name, templateId, criTierLevelId) {
    if (assessmentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}`,
        method: 'PUT',
        data: this.serializeData({
          name,
          templateId,
          criTierLevelId,
        }),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment`,
      method: 'POST',
      data: this.serializeData({
        id: assessmentId,
        name,
        templateId,
        criTierLevelId
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  completeAssessment(assessmentId, completedById, completedDate) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/complete`,
      method: 'PUT',
      data: this.serializeData({
        completedById,
        completedDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  uncompleteAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/uncomplete`,
      method: 'PUT',
    });
  }

  deleteAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}`,
      method: 'DELETE',
    });
  }

  boardApprove(assessmentId, approvalDate) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/boardApprove`,
      method: 'PUT',
      data: this.serializeData({
        approvalDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }
  
  // ///////////// Templates ////////////////////

  getTemplates() {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/template`,
      method: 'GET',
    });
  }

  getCustomerTemplates() {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/template/byCustomer`,
      method: 'GET',
    });
  }

  // ///////////// Settings ////////////////////

  // ///////////// Inherent Risk Profile ////////////////////

  getInherentRiskProfileByAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/inherentRiskProfile`,
      method: 'GET',
    });
  }

  saveBulkInherentRiskAssessment(assessmentId, factorOptions) {
    const data = {
      assessmentId,
      inherentRisks: factorOptions,
      echo: true,
    };
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentInherentRisk/bulkSave`,
      method: 'POST',
      data: this.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // ///////////// Maturity Profile ////////////////////

  getMaturityProfileByAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/maturityProfile`,
      method: 'GET',
    });
  }

  saveBulkMaturityAssessment(assessmentId, maturities) {
    const data = {
      assessmentId,
      maturities,
      echo: true,
    };
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentMaturity/bulkSave`,
      method: 'POST',
      data: this.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // ///////////// CRI Profile ////////////////////

  getCRIProfileByAssessment(assessmentId) {
     return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/CriProfile`,
      method: 'GET',
    }); 
  }

  getCRICategoriesByFunction(functionId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/cricategory/byFunction/${functionId}`,
      method: 'GET',
    });
  }

  getCRIInitData() {
    return this.$http({
     url: `${this.apiRootUrl}/ecat/template/init`,
     method: 'GET',
   }); 
 }

  saveBulkCRIAssessment(assessmentId, statements) {
    const data = {
      assessmentId,
      statements,
      echo: true,
    };
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentCri/bulkSave`,
      method: 'POST',
      data: this.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getCRIStatementsBySubCategory(assessmentId, subCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/cristatement/bySubCategory/${subCategoryId}`,
      method: 'GET',
      params: {},
    });
  }

  getCRIStatement(criStatementId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/cristatement/${criStatementId}`,
      method: 'GET',
      params: {},
    });
  }
  // ///////////// Statement Folders ////////////////////
  getCRIStatementFolder(criStatementFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementFolder/${criStatementFolderId}`,
      method: 'GET',
      params: {},
    });
  }

  getCRIStatementFoldersByFolder(assessmentId, folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/CRIStatementFolder/byFolder`,
      method: 'GET',
      params: {
        folderId,
      },
    });
  }

  getCRIStatementFoldersByStatement(assessmentId, criStatementId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/CRIStatement/${criStatementId}/CRIStatementFolder`,
      method: 'GET',
      params: {},
    });
  }

  attachCRIStatementFolder(assessmentId, CRIStatementId, folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementFolder`,
      method: 'POST',
      data: this.serializeData({
        assessmentId,
        CRIStatementId,
        folderId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachCRIStatementFolder(criStatementFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementFolder/${criStatementFolderId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Statement Documents ////////////////////
  getCRIStatementDocument(criStatementDocumentId) {
    console.log('getCRIDocument');
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementDocument/${criStatementDocumentId}`,
      method: 'GET',
      params: {},
    });
  }

  getCRIStatementDocumentsByFolder(assessmentId, folderId) {
    console.log('getCRIDocumentsByFolder');
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/folder/${folderId}/CRIStatementDocument`,
      method: 'GET',
      params: {},
    });
  }

  getCRIStatementDocumentsByStatement(assessmentId, criStatementId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/CRIStatement/${criStatementId}/CRIStatementDocument`,
      method: 'GET',
      params: {},
    });
  }

  attachCRIStatementDocument(assessmentId, criStatementId, documentId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementDocument`,
      method: 'POST',
      data: this.serializeData({
        assessmentId,
        CRIStatementId: criStatementId,
        documentId,
        name
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachCRIStatementDocument(criStatementDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementDocument/${criStatementDocumentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  updateCRIStatementDocument(criStatementDocument) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementDocument/${criStatementId.CRIStatementDocumentId}`,
      method: 'PUT',
      data: JSON.stringify(criStatementDocument),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  uploadCRIStatementDocument(criStatementId, criStatementDocument) {
    return _upload.upload({
      url: `${this.apiRootUrl}/ecat/CRIStatementDocument/${criStatementId}/document/upload`,
      data: {
        criStatementId,
        assessmentDocumentId: criStatementDocument.assessmentDocumentId,
        assessmentDocumentTypeId: criStatementDocument.assessmentDocumentTypeId,
        completedDate: criStatementDocument.completedDate,
        displayValue: criStatementDocument.name,
        isDeletable: criStatementDocument.deletable,
        file: criStatementDocument.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  checkCRIStatementDocumentDisplayNameExists(criStatementId, criStatementIdDocumentId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementDocument/checkDisplayNameExists/`,
      method: 'GET',
      params: {
        criStatementId,
        criStatementIdDocumentId,
        displayName,
      },
    });
  }

  checkCRIStatementDocumentFileNameExists(criStatementId, criStatementIdDocumentId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/CRIStatementDocument/checkFileNameExists/`,
      method: 'GET',
      params: {
        criStatementId,
        criStatementIdDocumentId,
        fileName,
      },
    });
  }

  // ///////////// Assessment Documents ////////////////////

  getAssessmentDocument(id) {
    console.log('getAssessmentDocument');
    return this.$http({
      url: `${this.apiRootUrl}/am/assessmentDocument/${id}`,
      method: 'GET',
      params: {}
    });
  }

  getAssessmentDocumentsByFolder(folderId) {
    console.log('getAssessmentDocumentsByFolder');
    return this.$http({
      url: `${this.apiRootUrl}/ecat/folder/${folderId}/assessmentDocument`,
      method: 'GET',
      params: {}
    });
  }

  getAssessmentDocumentsByAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/assessmentDocument`,
      method: 'GET',
      params: {}
    });
  }

  attachAssessmentDocument(assessmentId, documentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocument`,
      method: 'POST',
      data: this.serializeData({
        assessmentId,
        documentId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachAssessmentDocument(assessmentDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocument/${assessmentDocumentId}`,
      method: 'DELETE',
      params: {}
    });
  }

  deleteDocumentAttachment(documentAttachmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentAttachment/${documentAttachmentId}`,
      method: 'DELETE',
    });
  }

  uploadAssessmentDocument(assessmentId, assessmentDocument) {
    return _upload.upload({
      url: `${this.apiRootUrl}/ecat/assessment/${assessmentId}/document/upload`,
      data: {
        assessmentId,
        assessmentDocumentId: assessmentDocument.assessmentDocumentId,
        assessmentDocumentTypeId: assessmentDocument.assessmentDocumentTypeId,
        completedDate: assessmentDocument.completedDate,
        displayValue: assessmentDocument.name,
        isDeletable: assessmentDocument.deletable,
        file: assessmentDocument.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateAssessmentDocument(assessmentDocument) {
    /* eslint-disable */
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocument/${assessmentDocument.assessmentDocumentId}`,
      method: 'PUT',
      data: JSON.stringify(assessmentDocument),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteDocumentSupportingDocument(documentSupportingDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSupportingDocument/${documentSupportingDocumentId}`,
      method: 'DELETE',
    });
  }

  downloadAllAssessmentDocuments(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocument/downloadAll/${assessmentId}`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  checkAttachedDocumentDisplayNameExists(assessmentId, assessmentDocumentId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocument/checkDisplayNameExists/`,
      method: 'GET',
      params: {
        assessmentId,
        assessmentDocumentId,
        displayName,
      }
    });
  }

  checkAttachedDocumentFileNameExists(assessmentId, assessmentDocumentId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocument/checkFileNameExists/`,
      method: 'GET',
      params: {
        assessmentId,
        assessmentDocumentId,
        fileName,
      }
    });
  }

  // ///////////// Assessment Document Types ////////////////////

  getAssessmentDocumentTypes() {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocumentType`,
      method: 'GET',
      params: {}
    });
  }

  getAssessmentDocumentType(id) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocumentType/${id}`,
      method: 'GET',
      params: {}
    });
  }

  saveAssessmentDocumentType(assessmentDocumentType) {
    if (assessmentDocumentType.assessmentDocumentTypeId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/ecat/assessmentDocumentType/${assessmentDocumentType.assessmentDocumentTypeId}`,
        method: 'PUT',
        data: JSON.stringify(assessmentDocumentType),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocumentType/${assessmentDocumentType.assessmentDocumentTypeId}`,
      method: 'POST',
      data: JSON.stringify(assessmentDocumentType),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteAssessmentDocumentType(id) {
    return this.$http({
      url: `${this.apiRootUrl}/ecat/assessmentDocumentType/${id}`,
      method: 'DELETE',
      params: {}
    });
  }  

  // ///////////// Assessment Package ///////////////////

  generateAssessmentPackageFileList(assessmentId) {
    return this.$http.post(
      `${this.apiRootUrl}/ecat/assessmentPackage`,
      {},
      {
        params: {
          action: 'generateAssessmentPackageList',
          assessmentId,
        },
      },
    );
  }

  createAssessmentPackageFileGenerationRequest(assessmentId) {
    return this.$http.post(`${this.apiRootUrl}/ecat/assessment/${assessmentId}/generateAssessmentPackage`, {}, {});
  }
  
  downloadPackage(assessmentPackageId) {
    const url = `${this.apiRootUrl}/ecat/assessmentPackage/${assessmentPackageId}/download`;
    return this.$http({
      url,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  download(response) {
    const contentType = response.headers('Content-Type');
    const contentDisposition = response.headers('Content-Disposition');
    let fileName = '';

    if (!R.isNil(contentDisposition)) {
      // const matches = /filename="(.*?)"/g.exec(contentDisposition);
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      fileName = matches && matches.length > 1 ? matches[1] : null;
      fileName = fileName.split('"').join('');
    }

    const blob = new Blob([response.data], { type: contentType });
    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = fileName;
      anchor.target = '_self';
      anchor.click();
    }
  }
}

ecatDataService.$inject = [
  '$http',
  'Upload',
  'utilityService'
];

export default angular.module('app.services.ecatDataService', [
  ngFileUpload,
])
  .service('ecatDataService', ecatDataService)
  .name;
